import { FC } from "react";
import { Font, Row } from "../../../TrueUI";
import { rowWithNoMarginNorGutter } from "../../../TrueUI/Grids/Row";

const ErrorBody: FC<{ bindPolicyErrors: any }> = ({ bindPolicyErrors }) => {
  return (
    <Row
      {...rowWithNoMarginNorGutter}
      rowDirection="column"
      verticalAlign="flex-start"
    >
      <Font textAlign="start" whiteSpace="normal">
        AN ERROR HAS OCURRED!
      </Font>
      <Font textAlign="start" whiteSpace="normal">
        {bindPolicyErrors}
      </Font>
    </Row>
  );
};
export default ErrorBody;
